import { useEffect, useRef } from "react";

export const useReportFormDirty = (isDirty: boolean, onDirtyChange?: (isDirty: boolean) => void) => {
  const callbackRef = useRef(onDirtyChange);
  callbackRef.current = onDirtyChange;

  useEffect(() => {
    callbackRef.current?.(isDirty);
  }, [isDirty]);

  useEffect(() => {
    return () => {
      callbackRef.current?.(false);
    };
  }, []);
};
